"use client";

import { useTranslations } from "@frontend/lib/next-intl-typed";
import { cn } from "@frontend/shared/lib/utils";
import Image from "next/image";
import { useParams } from "next/navigation";

export const Footer = ({
  classNames,
  primaryColor,
}: { classNames: string; primaryColor: string }) => {
  const clientSlug = useParams<{ clientSlug: string }>().clientSlug;
  const isLg = true;
  const t = useTranslations("Shop");

  const handleDownload = async (docType: string) => {
    try {
      const response = await fetch(
        `/api/policy?clientSlug=${clientSlug}&type=${docType}`,
        {
          method: "GET",
        },
      );

      if (!response.ok) {
        throw new Error("Download failed");
      }

      // Create a blob from the PDF stream
      const blob = await response.blob();
      // Create a link element
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `${docType}.pdf`;

      // Append to the document and trigger the download
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Cleanup
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  return (
    <div
      style={{ backgroundColor: primaryColor }}
      className={cn(
        "lg:min-h-[230px] sm:min-h-[230px] flex w-full justify-center items-center border-t bg-black text-white",
        classNames,
      )}
    >
      <div className="h-full flex w-[80vw] lg:flex-row sm:flex-col lg:items-end lg:justify-between sm:items-center sm:justify-between lg:gap-0 sm:gap-8 py-8 pt-12">
        {isLg && (
          <div className="flex lg:flex-row sm:flex-col h-[24px] lg:justify-start sm:justify-center items-center gap-[4px] w-full">
            <p className="font-light font-suisse text-base">Powered by</p>
            <Image
              src={"/images/logowhite.svg"}
              alt="superscript logo"
              width={127}
              height={27}
              className="mt-[2px]"
            />
          </div>
        )}

        <div className="flex gap-8 sm:items-center sm:justify-center sm:w-full lg:items-center lg:justify-end">
          <button
            type="button"
            onClick={() => handleDownload("terms-of-use")}
            className="font-light text-[14px] sm:text-[11px] cursor-pointer"
          >
            {t("TermsAndConditions")}
          </button>

          <div className="w-[1px] h-[18px] bg-white" />

          <button
            type="button"
            onClick={() => handleDownload("privacy-policy")}
            className="font-light text-[14px] sm:text-[11px] cursor-pointer"
          >
            {t("PrivacyPolicy")}
          </button>
        </div>
      </div>
    </div>
  );
};
